import React from 'react';
import { Check, Shield, Download, Smartphone } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="pt-12 pb-16 px-4 bg-white" data-id="element-74">
      <div className="max-w-4xl mx-auto text-center" data-id="element-75">
        <h1 className="text-3xl md:text-5xl font-heading font-black leading-tight mb-8 text-black uppercase tracking-tight" data-id="element-76">
          🌿 <span className="highlight-yellow" data-id="element-77">Empezá HOY MISMO</span> a
          aliviar dolores, dormir mejor y recuperar tu bienestar de forma
          natural
        </h1>

        <a href="https://impulsodigital.vip/cart/44742359646294:1" className="block mb-8 hover:opacity-95 transition-opacity" data-id="element-78">
          <img src="https://cdn.magicpatterns.com/uploads/fWKo2t3hijFnJB6rDmF5TH/hf_20260327_220519_0b0f6238-3b57-4318-999a-2c6531e204a0.webp" alt="Más de 300 Remedios Naturales de la Abuela" className="w-full max-w-md mx-auto rounded-lg shadow-2xl border border-gray-200" data-id="element-79" />
        </a>

        <p className="text-xl md:text-2xl font-medium text-gray-800 mb-6 leading-relaxed" data-id="element-80">
          Descubrí más de 300 remedios naturales paso a paso para cuidar tu
          salud y la de tu familia sin depender constantemente de pastillas.
        </p>

        <div className="bg-yellow-100 border-2 border-yellow-400 text-yellow-900 font-bold text-lg md:text-xl py-3 px-6 rounded-lg inline-block mb-8 shadow-sm" data-id="element-81">
          ✨ Además hoy recibís 10 guías digitales de regalo.
        </div>

        <div className="max-w-2xl mx-auto text-left mb-10 bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-82">
          <ul className="space-y-3" data-id="element-83">
            {['Más de 300 remedios naturales organizados por síntomas', 'Soluciones naturales fáciles y prácticas', 'Ingredientes simples y accesibles', 'Formato digital con acceso inmediato', 'Ideal para toda la familia', 'Compatible con celular y computadora'].map((bullet, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-84">
                <Check className="w-6 h-6 text-brand-green flex-shrink-0 mt-0.5" data-id="element-85" />
                <span className="text-lg font-medium text-gray-800" data-id="element-86">
                  {bullet}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="mb-8" data-id="element-87">
          <p className="text-2xl text-gray-500 line-through font-bold mb-2" data-id="element-88">
            $49.990
          </p>
          <p className="text-5xl md:text-6xl font-black text-brand-red animate-pulse" data-id="element-89">
            👉 HOY SOLO $14.990 ARS
          </p>
        </div>

        <CTAButton subtext="(Oferta válida por tiempo limitado)" data-id="element-90" />

        <div className="flex flex-col md:flex-row items-center justify-center gap-6 mt-8 text-sm font-medium text-gray-600" data-id="element-91">
          <div className="flex items-center gap-2" data-id="element-92">
            <Shield className="w-5 h-5 text-gray-800" data-id="element-93" />
            <span data-id="element-94">Compra segura</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-95">
            <Download className="w-5 h-5 text-gray-800" data-id="element-96" />
            <span data-id="element-97">Descarga inmediata</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-98">
            <Smartphone className="w-5 h-5 text-gray-800" data-id="element-99" />
            <span data-id="element-100">Acceso desde cualquier dispositivo</span>
          </div>
        </div>
      </div>
    </section>;
}